import { combineReducers } from 'redux'

import { fiat } from './fiat'
import { crypto } from './crypto'

export const invoice = combineReducers({
  fiat,
  crypto
})
